exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".main-content[data-v-4edd20f8]{width:100%;max-width:calc(100% - 180px);margin-left:auto}@media only screen and (max-width:991px){.main-content[data-v-4edd20f8]{max-width:100%}}", ""]);
